import { useEffect, useState } from 'react';
import { IForm as IStepOneForm, StepOne, StepThree, StepTwo } from './widgets';

enum StepEnum {
  First = 1,
  Second = 2,
  Third = 3,
}

export const PasswordRecovery = () => {
  const [step, setStep] = useState<StepEnum>(StepEnum.First);
  const [formData, setFormData] = useState<IStepOneForm>();

  useEffect(() => {
    return () => {
      setStep(StepEnum.First);
      setFormData(undefined);
    };
  }, []);

  return (
    <>
      {step === StepEnum.First && (
        <StepOne
          onSubmit={(data) => {
            setFormData(data);
            setStep(StepEnum.Second);
          }}
        />
      )}
      {step === StepEnum.Second && <StepTwo recoveryData={formData!} onSubmit={() => setStep(StepEnum.Third)} />}
      {step === StepEnum.Third && <StepThree />}
    </>
  );
};
